import React from 'react';

const Hero = () => {
  return (
    <>
    <section id="hero" className="hero">
      <div className="hero-background">
        <div className="thunder-burst burst-1">
          <svg className="mini-thunder" viewBox="0 0 10 16">
            <path d="M5,1 L3,8 L6,8 L4,15 L7,9 L5,9 Z" fill="currentColor"/>
          </svg>
        </div>
        <div className="thunder-burst burst-2">
          <svg className="mini-thunder" viewBox="0 0 8 14">
            <path d="M4,1 L2,7 L5,7 L3,13 L6,8 L4,8 Z" fill="currentColor"/>
          </svg>
        </div>
        <div className="thunder-burst burst-3">
          <svg className="mini-thunder" viewBox="0 0 12 18">
            <path d="M6,1 L4,9 L7,9 L5,17 L8,10 L6,10 Z" fill="currentColor"/>
          </svg>
        </div>
        <div className="thunder-burst burst-4">
          <svg className="mini-thunder" viewBox="0 0 9 15">
            <path d="M4.5,1 L3,7 L6,7 L4,14 L7,8 L4.5,8 Z" fill="currentColor"/>
          </svg>
        </div>
        <div className="thunder-burst burst-5">
          <svg className="mini-thunder" viewBox="0 0 11 17">
            <path d="M5.5,1 L3.5,8 L7.5,8 L5.5,16 L8.5,9 L5.5,9 Z" fill="currentColor"/>
          </svg>
        </div>
        <div className="thunder-burst burst-6">
          <svg className="mini-thunder" viewBox="0 0 8 13">
            <path d="M4,1 L2.5,6 L5.5,6 L3.5,12 L6.5,7 L4,7 Z" fill="currentColor"/>
          </svg>
        </div>
        <div className="thunder-bg thunder-bg-1">
          <svg className="thunder-line-bg" viewBox="0 0 100 20" preserveAspectRatio="none">
            <path d="M0,10 L20,10 L25,5 L30,15 L35,5 L40,15 L45,10 L100,10" stroke="currentColor" fill="none" strokeWidth="2"/>
          </svg>
        </div>
        <div className="thunder-bg thunder-bg-2">
          <svg className="thunder-line-bg" viewBox="0 0 100 20" preserveAspectRatio="none">
            <path d="M0,8 L15,8 L20,12 L28,4 L35,12 L42,6 L50,10 L100,10" stroke="currentColor" fill="none" strokeWidth="1.5"/>
          </svg>
        </div>
        <div className="thunder-bg thunder-bg-3">
          <svg className="thunder-line-bg" viewBox="0 0 100 20" preserveAspectRatio="none">
            <path d="M0,12 L25,12 L30,16 L35,8 L40,14 L45,6 L50,12 L100,12" stroke="currentColor" fill="none" strokeWidth="1"/>
          </svg>
        </div>
        <div className="thunder-bg thunder-bg-4">
          <svg className="thunder-line-bg" viewBox="0 0 100 20" preserveAspectRatio="none">
            <path d="M0,6 L18,6 L23,10 L30,2 L37,10 L44,4 L52,8 L100,8" stroke="currentColor" fill="none" strokeWidth="1.5"/>
          </svg>
        </div>
        <div className="thunder-bg thunder-bg-5">
          <svg className="thunder-line-bg" viewBox="0 0 100 20" preserveAspectRatio="none">
            <path d="M0,14 L22,14 L27,18 L32,10 L39,16 L46,8 L54,14 L100,14" stroke="currentColor" fill="none" strokeWidth="1"/>
          </svg>
        </div>
        <div className="thunder-bg thunder-bg-6">
          <svg className="thunder-line-bg" viewBox="0 0 100 20" preserveAspectRatio="none">
            <path d="M0,4 L12,4 L17,8 L24,0 L31,8 L38,2 L46,6 L100,6" stroke="currentColor" fill="none" strokeWidth="1.5"/>
          </svg>
        </div>
        <div className="thunder-bg thunder-bg-7">
          <svg className="thunder-line-bg" viewBox="0 0 100 20" preserveAspectRatio="none">
            <path d="M0,16 L28,16 L33,20 L38,12 L43,18 L48,10 L56,16 L100,16" stroke="currentColor" fill="none" strokeWidth="1"/>
          </svg>
        </div>
        <div className="thunder-bg thunder-bg-8">
          <svg className="thunder-line-bg" viewBox="0 0 100 20" preserveAspectRatio="none">
            <path d="M0,9 L16,9 L21,13 L28,5 L35,13 L42,7 L50,11 L100,11" stroke="currentColor" fill="none" strokeWidth="1.5"/>
          </svg>
        </div>
        
        <div className="falling-thunder falling-thunder-1">
          <svg viewBox="0 0 20 40" className="thunder-bolt">
            <path d="M10,2 L6,18 L12,18 L8,38 L14,22 L10,22 Z" fill="currentColor"/>
          </svg>
        </div>
        <div className="falling-thunder falling-thunder-2">
          <svg viewBox="0 0 16 32" className="thunder-bolt">
            <path d="M8,1 L5,14 L9,14 L6,30 L11,17 L8,17 Z" fill="currentColor"/>
          </svg>
        </div>
        <div className="falling-thunder falling-thunder-3">
          <svg viewBox="0 0 18 36" className="thunder-bolt">
            <path d="M9,1 L5,16 L10,16 L7,34 L12,19 L9,19 Z" fill="currentColor"/>
          </svg>
        </div>
        <div className="falling-thunder falling-thunder-4">
          <svg viewBox="0 0 14 28" className="thunder-bolt">
            <path d="M7,1 L4,12 L8,12 L5,26 L10,15 L7,15 Z" fill="currentColor"/>
          </svg>
        </div>
        <div className="falling-thunder falling-thunder-5">
          <svg viewBox="0 0 22 44" className="thunder-bolt">
            <path d="M11,2 L7,20 L13,20 L9,42 L15,24 L11,24 Z" fill="currentColor"/>
          </svg>
        </div>
        <div className="falling-thunder falling-thunder-6">
          <svg viewBox="0 0 12 24" className="thunder-bolt">
            <path d="M6,1 L3,10 L7,10 L4,22 L9,13 L6,13 Z" fill="currentColor"/>
          </svg>
        </div>
        <div className="falling-thunder falling-thunder-7">
          <svg viewBox="0 0 16 32" className="thunder-bolt">
            <path d="M8,1 L5,14 L9,14 L6,30 L11,17 L8,17 Z" fill="currentColor"/>
          </svg>
        </div>
        <div className="falling-thunder falling-thunder-8">
          <svg viewBox="0 0 10 20" className="thunder-bolt">
            <path d="M5,1 L3,8 L6,8 L4,18 L7,11 L5,11 Z" fill="currentColor"/>
          </svg>
        </div>
      </div>
      <div className="container">
        <div className="hero-content">
          <h1>
            AI customer service that <span className="highlight">works while you sleep</span>
          </h1>
          <p className="hero-subtitle">
            Transform your customer experience with intelligent automation. Handle unlimited conversations, 
            capture leads 24/7, and reduce support costs by 80% – all while maintaining the personal touch your customers expect.
          </p>
          <div className="hero-buttons">
            <a href="https://calendly.com/dimitrovovich" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
              Start Free Consultation
            </a>
            <a href="#process" className="btn btn-secondary">
              See How It Works
            </a>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default Hero;